<script setup>
import {defineProps, onMounted, ref} from 'vue'
const props = defineProps({
  email: {
    type: String,
    required: true
  }
});
const noEmail = ref(false);
const checkNoEmail = () => {
  if (props.email.split('@')[1] === 'no_email.com') {
    noEmail.value = true;
  }
}
onMounted(() => checkNoEmail())
</script>

<template>
  <a
      v-if="!noEmail"
      :href="'mailto:' + props.email"
      class="inline-flex items-center justify-center space-x-2 px-2 py-1 rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600">
    <span class="material-icons-round" style="font-size: 16px;">mail_outlined</span> {{ props.email }}</a>
  <span v-else>
    <span class="material-icons" style="font-size: 16px;">info</span> No have email
  </span>
</template>

<style scoped>

</style>